/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serial_Number_TakenInputs */



/**
* | output |
* | --- |
* | "Serial number already assigned" |
*
* @param {Serial_Number_TakenInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const serial_number_taken = /** @type {((inputs?: Serial_Number_TakenInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serial_Number_TakenInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Serial number already assigned")
	return /** @type {LocalizedString} */ ("Numéro de série déjà attribué")
});